/**
 * Ledger Entry List Component
 * Displays a list of ledger entries
 */

import { type LedgerEntry } from '../../lib/api';
import { LedgerEntryRow } from './LedgerEntryRow';

interface LedgerEntryListProps {
  entries: LedgerEntry[];
  isLoading?: boolean;
}

export function LedgerEntryList({ entries, isLoading }: LedgerEntryListProps) {
  if (isLoading) {
    return (
      <div
        data-testid="ledger-loading"
        className="p-8 text-center bg-accent/50 rounded-md"
      >
        <div className="text-5xl mb-3">⏳</div>
        <p className="text-base text-muted-foreground m-0">
          Loading ledger entries...
        </p>
      </div>
    );
  }

  if (entries.length === 0) {
    return (
      <div
        data-testid="ledger-empty"
        className="p-8 text-center bg-accent/50 rounded-md"
      >
        <div className="text-5xl mb-3">📋</div>
        <p className="text-base text-muted-foreground m-0">
          No ledger entries yet
        </p>
        <p className="text-sm text-muted-foreground mt-1 m-0">
          Charges and payments will appear here
        </p>
      </div>
    );
  }

  return (
    <div data-testid="ledger-entry-list" className="grid gap-3">
      {entries.map((entry) => (
        <LedgerEntryRow key={entry.id} entry={entry} />
      ))}
    </div>
  );
}
